import s from './membership.Style';
import { styled } from 'styled-components';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { req } from '../../../@api/request';

interface StandardProps {
  plans: any[];
  month: number;
}

declare global {
  interface Window {
    wcs: any; // 또는 정확한 타입이 있다면 그걸로
    wcs_add?: any;
  }
}

interface IFormData {
  P_INI_PAYMENT: string;
  P_MID: string;
  P_OID: string;
  P_AMT: number;
  P_GOODS: string;
  P_UNAME: string;
  P_NEXT_URL: string;
  P_RESERVED: string;
  url: string;
}

const Standard = ({ plans, month }: StandardProps) => {
  const server = new URL(
    process.env.REACT_APP_HOST_API || 'http://localhost:3333/',
  ).origin;

  const defaultPlan = useMemo(
    () => plans.find((plan) => plan.is_discount === 'Y'),
    [plans],
  );

  const [selectedPlan, setSelectedPlan] = useState(defaultPlan);
  const [formData, setFormData] = useState<IFormData>();
  const [onDrop, setOnDrop] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const formattedPrice = selectedPlan?.plan_prc.toLocaleString('ko-KR');

  const normalPrice = (selectedPlan.plan_prc * 2).toLocaleString('ko-KR');

  useEffect(() => {
    const newDefault = plans.find((plan) => plan.is_discount === 'Y');
    if (newDefault) {
      setSelectedPlan(newDefault);
    }
  }, [plans]);

  useEffect(() => {
    if (onDrop) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [onDrop]);

  const handlePayment = async () => {
    if (!selectedPlan.plan_id) {
      alert('결제할 상품을 선택해주세요.');
      return;
    }

    try {
      const res = await req.get(`payment/${selectedPlan.plan_id}`);
      setFormData({
        P_INI_PAYMENT: 'CARD',
        P_MID: res.data.data.mid,
        P_OID: res.data.data.oid,
        P_AMT: res.data.data.price,
        P_GOODS: res.data.data.goodname,
        P_UNAME: res.data.data.userName,
        P_NEXT_URL: `${server}/payment/auth/phone?front=${window.location.origin}`,
        P_RESERVED: 'centerCd=Y',
        url: 'https://mobile.inicis.com/smart/payment/',
      });
    } catch (error: any) {
      console.error(error.response.data.message);
    }
  };

  const naver_script = () => {
    if (window.wcs) {
      if (!window.wcs_add as any) window.wcs_add = {};
      window.wcs_add['wa'] = 's_2489d344048e';
      var _conv: any = {};
      _conv.type = 'begin_checkout'; //(필수)
      _conv.items = [
        {
          id: selectedPlan.plan_id,
          name: selectedPlan.name,
          payAmount: selectedPlan.plan_prc,
        },
      ];
      window.wcs.trans(_conv);
    }
  };

  useEffect(() => {
    if (formData && formRef.current) {
      naver_script();
      formRef.current.submit();
    }
  }, [formData]);

  return (
    <s.Container>
      <s.Div>
        <s.Top>
          <s.Title>Standard</s.Title>
          <s.Comment>
            합리적인 가격으로 나에게 맞는 알고리즘을 만들고 월 1회 투자보고서도
            받아보세요
          </s.Comment>
        </s.Top>
        <s.PriceDiv>
          <s.Discount>
            <s.EarlyBird
              style={{
                visibility:
                  selectedPlan?.is_discount === 'Y' ? 'visible' : 'hidden',
              }}
            >
              얼리버드 특전 -50%
            </s.EarlyBird>
            <s.NormalPrice
              style={{
                visibility:
                  selectedPlan?.is_discount === 'Y' ? 'visible' : 'hidden',
              }}
            >
              <s style={{ fontSize: '16px', color: '#616161' }}>
                {normalPrice}원
              </s>
            </s.NormalPrice>
          </s.Discount>
          <s.Row>
            <span style={{ fontWeight: '700', fontSize: '28px' }}>
              {formattedPrice}
            </span>
            {month === 12 ? (
              <span
                style={{
                  fontWeight: '500',
                  fontSize: '16px',
                  color: 'rgba(55, 56, 60, 0.61)',
                }}
              >
                / 1년
              </span>
            ) : (
              <span
                style={{
                  fontWeight: '500',
                  fontSize: '16px',
                  color: 'rgba(55, 56, 60, 0.61)',
                }}
              >
                / {month}개월
              </span>
            )}
          </s.Row>
        </s.PriceDiv>
        <div style={{ position: 'relative' }}>
          <Drop onDrop={onDrop} onClick={() => setOnDrop(true)}>
            <span style={{ fontWeight: '700', fontSize: '16px' }}>
              {selectedPlan.plan_name}
            </span>
            <img
              src="/assets/images/arrow/arrow-down-gray.svg"
              alt="Inquiry"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
          </Drop>

          {onDrop && (
            <BottomSheetOverlay onClick={() => setOnDrop(false)}>
              <BottomSheet onClick={(e) => e.stopPropagation()}>
                <Header>
                  지역 선택
                  <CloseButton
                    onClick={() => setOnDrop(false)}
                    src="/assets/images/close/close_gray_24.svg"
                  />
                </Header>
                {plans.map((plan) => (
                  <BottomSheetItem
                    key={plan.plan_id}
                    onClick={() => {
                      setSelectedPlan(plan);
                      setOnDrop(false);
                    }}
                  >
                    <BottomSheetItemText>
                      <img
                        src={
                          plan.plan_id === selectedPlan?.plan_id
                            ? '/assets/images/check/blue_check_32.svg'
                            : '/assets/images/check/gray_check_20.svg'
                        }
                        style={{ width: '20px', height: '20px' }}
                      />
                      {plan.plan_name}
                    </BottomSheetItemText>
                    <BottomSheetItemText style={{ color: '#616161' }}>
                      {plan.plan_prc.toLocaleString()}원
                    </BottomSheetItemText>
                  </BottomSheetItem>
                ))}
              </BottomSheet>
            </BottomSheetOverlay>
          )}
        </div>

        <s.StartButton
          onClick={handlePayment}
          disabled={selectedPlan?.is_discount === 'Y'}
        >
          {selectedPlan?.is_discount === 'Y'
            ? '전국 얼리버드 특전(곧 오픈)'
            : '시작하기'}
        </s.StartButton>
      </s.Div>
      <div style={{ width: '100%' }}>
        <s.BenefitList>
          <s.Row style={{ gap: '0px', fontSize: '16px' }}>
            <span style={{ color: '#008AFF' }}>Standard</span>
            <span>의 모든 기능 +</span>
          </s.Row>
          <s.Benefit>
            <img
              src="/assets/images/check/gray_check_20.svg"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
            <span>모든 경공매검색 이용 가능</span>
          </s.Benefit>
          <s.Benefit>
            <img
              src="/assets/images/check/gray_check_20.svg"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
            <span>알고리즘 분석 이용 가능</span>
          </s.Benefit>
          <s.Benefit>
            <img
              src="/assets/images/check/gray_check_20.svg"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
            <span>퀀트 상세 정보 맛보기 10건</span>
          </s.Benefit>
          <s.Benefit>
            <img
              src="/assets/images/check/gray_check_20.svg"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
            <span>VIP 투자보고서 월 1건 제공 </span>
          </s.Benefit>
          <s.Benefit>
            <img
              src="/assets/images/check/gray_check_20.svg"
              style={{
                width: '24px',
                height: '24px',
              }}
            />
            <span>시/군/구 낙찰통계 제공</span>
          </s.Benefit>
        </s.BenefitList>
      </div>
      {formData && (
        <div>
          <form
            method="POST"
            acceptCharset="euc-kr"
            action={formData.url}
            ref={formRef}
            style={{ display: 'none' }}
          >
            {Object.entries(formData).map(([key, value]) => {
              return (
                <input
                  key={key}
                  type="text"
                  name={key}
                  value={value}
                  readOnly
                />
              );
            })}
          </form>
        </div>
      )}
    </s.Container>
  );
};

export default Standard;

const Drop = styled.div<{ onDrop: boolean }>`
  padding: 14px 16px;
  border: ${({ onDrop }) =>
    onDrop ? '1px solid #008AFF' : '1px solid rgba(23, 30, 38, 0.1)'};
  border-radius: 5px;
  font-size: 14px;
  font-color: #222222;
  display: flex;
  flex-direction: row;
  position: relative;
  cursor: pointer;
  user-select: none;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f8fc;
`;

const BottomSheetOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 1000;
`;

const BottomSheet = styled.div`
  width: 100%;
  max-height: 70%;
  background-color: #fff;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  overflow-y: auto;
  padding: 0px 16px 40px;
`;

const BottomSheetItem = styled.div`
  padding: 14px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const BottomSheetItemText = styled.span`
  font-size: 16px;
  font-weight: 500;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1px;
`;

const Header = styled.div`
  position: relative;
  font-size: 18px;
  font-weight: 700;
  padding: 16px;
  text-align: center;
`;

const CloseButton = styled.img`
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;
